import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { WindowService } from 'src/app/core/services/window.service';

@Component({
    selector: '.text-gradient',
    templateUrl: './text-gradient.component.html',
    styleUrls: ['./text-gradient.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.apple]': `appleDevices`
    }
})
export class TextGradientComponent implements OnInit {
  private _window = inject(WindowService);


  get appleDevices() {
    return this._window.isSafari || this._window.isIphoneDevices;
  }

  ngOnInit(): void {

  }

}
